module.exports = __webpack_public_path__ + "static/media/bg-image-22.8f3f5eb4.jpg";